import { Modal, ModalFooter, ModalTitle, ModalBody, ModalHeader } from '@common/components/modal';
import { I18n } from 'react-redux-i18n';

import { Button } from '@common/components/Button';
import { MODULE_NAME } from '../../audit-report';
import { Flex } from '@common/components/Flex';
import { Users } from './components/users';
import { Dates } from './components/dates';
import { Updates } from './components/updates';
import { getAuditingFields, getFilteringConfig, getFolders } from '../../actions/main';

import './new-report.styles.scss';

export const NewReport = (props) => {
  const { defaultSelectedUsers, defaultDates, defaultUpdates, onSubmit, onClose, showMessage } = props;
  const [config, setConfig] = React.useState();
  const [selectedUsers, setSelectedUsers] = React.useState(defaultSelectedUsers);
  const [dates, setDates] = React.useState(defaultDates);
  const [updates, setUpdates] = React.useState(defaultUpdates);

  const [submitting, setSubmitting] = React.useState(false);

  React.useEffect(() => {
    getFilteringConfig().then(setConfig);
  }, []);

  const handleSubmit = React.useCallback(async () => {
    const validations = [
      {
        message: 'Please select at least one field in the "Show Updates for" section',
        isValid: (updates.individual.use && updates.individual.value) || (updates.pedigree.use && updates.pedigree.value)
      }
    ];

    const errorMessage = validations.find(({ isValid }) => !isValid)?.message;

    if (errorMessage) {
      showMessage({ header: I18n.t('Validation error'), text: I18n.t(errorMessage), size: 'middle' });

      return;
    }

    try {
      setSubmitting(true);

      await onSubmit({
        dates,
        updates,
        users: selectedUsers,
      });
    } catch (err) {
      setSubmitting(false);
      console.error(err);
    }
  }, [onSubmit, dates, selectedUsers, onClose, updates]);

  return (
    <Modal
      show
      backdrop="static"
      bsClass="bootstrap modal"
      className="FieldAuditReportNewReport"
      animation={false}
      onEscapeKeyDown={onClose}
      onHide={onClose}
    >
      <ModalHeader closeButton onHide={onClose} className="FieldAuditReportNewReport__header">
        <ModalTitle id={`${MODULE_NAME}-new-report-data-header`}>
          {I18n.t('New Report')}
        </ModalTitle>
      </ModalHeader>

      <ModalBody className="FieldAuditReportNewReport__content">
        {!config && (
          <Flex alignItems="center" justify="center" className="FieldAuditReportNewReport__loading">{I18n.t('Loading')}...</Flex>
        )}
        {config && (
          <>
            <Dates value={dates} onChange={setDates} />
            <Users data={config.usernames} value={selectedUsers} onChange={setSelectedUsers} />
            <Updates 
              getFields={getAuditingFields}
              getFolders={getFolders}
              value={updates}
              onChange={setUpdates}
            />
            <Flex justify="flex-end" className="FieldAuditReportNewReport__content__footer">
              <Button 
                className="FieldAuditReportNewReport__content__cancel-btn"
                disabled={submitting}
                id={`${MODULE_NAME}-new-report-cancel-button`} 
                onClick={onClose}
              >
                {I18n.t('Cancel')}
              </Button>
              <Button 
                bsStyle="primary"
                className="FieldAuditReportNewReport__content__submit-btn"
                disabled={submitting}
                id={`${MODULE_NAME}-new-report-submit-button`} 
                onClick={handleSubmit}
              >
                {submitting ? I18n.t('Loading') : I18n.t('Save')}
              </Button>
            </Flex>
          </>
        )}
      </ModalBody>
    </Modal>
  );
};